<template>
    <div class="drop-zone" v-if="items">
        <div
            class="drag-el"
            v-for="(item, index) in items"
            :key="item.id"
            draggable="true"
            @dragenter.prevent="onDragEnter(index)"
            @dragstart="startDrag($event, item)"
            @drop="onDrop($event, index)"
            @dragover.prevent="onOver($event)"
            @dragleave.prevent="onLeave"
            :class="{ 'on-over': overIndex === index }"
        >
            <i class="fa fa-arrows-alt"></i> &nbsp; {{ item.name }}
        </div>
    </div>
</template>

<script>
import ApiManager from './Api/ApiManagerActivity.js'

export default {
    props: {
        slug: {
            required: true,
        },
    },

    data() {
        return {
            items: [],
            overIndex: -1, // Track the index of the item being hovered over
        }
    },

    methods: {
        async fetchPrestations() {
            try {
                const params = new URLSearchParams({
                    categories: [this.slug].join(','),
                    select: ['id', 'slug', 'name'],
                    groupBy: [],
                })
                const data = await ApiManager.fetchPrestations(params)
                this.items = data.data
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        async changeOrder(index) {
            try {
                const payload = {
                    items: index,
                }
                await ApiManager.changeOrder(payload)
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        startDrag(event, item) {
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('itemId', item.id)
        },

        onOver(event) {
            event.preventDefault()
        },

        onDragEnter(index) {
            this.overIndex = index // Update the overIndex when dragging enters
        },

        onLeave() {
            this.overIndex = -1 // Reset overIndex on leave
        },

        onDrop(event, index) {
            this.onLeave()
            const itemId = event.dataTransfer.getData('itemId')
            const item = this.items.find((item) => item.id == itemId)
            const itemPosition = this.items.findIndex((item) => item.id == itemId)
            this.items.splice(itemPosition, 1)
            this.items.splice(index, 0, item)
            const idIndexArray = this.items.map((item, index) => ({ id: item.id, index: index + 1 }))
            this.changeOrder(idIndexArray)
        },

        getIndex(event) {
            // Implementation for retrieving index if needed
        },
    },

    async mounted() {
        await this.fetchPrestations()
    },
}
</script>

<style scoped lang="scss">
.drop-zone {
    max-width: 600px;
    margin: 0 auto;
    color: var(--c-text, #ffffffde);
    padding: 30px;
    border-radius: 8px;
    transition: background-color 0.3s ease;

    @media (max-width: 768px) {
        padding: 15px;
    }
}

.drag-el {
    padding: 12px 25px;
    border: 1px solid var(--c-border, #021832);
    border-radius: 8px;
    background-color: var(--c-bg-card, #021832);
    transition:
        background-color 0.3s ease,
        transform 0.2s ease;
    cursor: grab;

    &:not(:last-child) {
        margin-bottom: 10px;
    }

    &:hover {
        background-color: var(--c-bg-card, #09274d);
    }
}

.on-over {
    border-color: #33a06f;
    background-color: var(--c-bg-card, #082f5f);
    transform: scale(1.02);
}
</style>
